export enum FontHeight {
  lineHeightDefault = '100%',
  lineHeightXs = '115%',
  lineHeightSm = '120%',
  lineHeightMd = '133%',
  lineHeightLg = '150%',
  lineHeightXl = '170%',
  lineHeightXxl = '200%',
}

export default FontHeight

export type TLineHeight =
  | 'lineHeightDefault'
  | 'lineHeightXs'
  | 'lineHeightSm'
  | 'lineHeightMd'
  | 'lineHeightLg'
  | 'lineHeightXl'
  | 'lineHeightXxl'
